// extracted by mini-css-extract-plugin
export default {"header":"Feedback_header__0rJ3P","text":"Feedback_text__lLi9U","wrapper":"Feedback_wrapper__hjTN4","feedback":"Feedback_feedback__8f+1j"};